<template>
  <focus-lock>
    <el-dialog
      ref="closedAccountDialog"
      v-loading.fullscreen.lock="mainLoader"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="closed-account-dialog"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      title="Are you sure? We’ll store your data for 30 days, during which time you can change your mind. After 30 days we‘ll permanently delete your data and we won’t be able to recover it for you."
      @opened="dialogOpen('closedAccountDialog')"
      @close="onClose($event)"
    >
      <div class="body">
        <svg-danger-exclamation />
        <h1>New owner nominated</h1>
        <p>
          You have nominated <strong>{{ newOwner.full_name }}</strong> as your new organisation owner - confirming this will {{ action }} your account and transfer ownership to them.
        </p>
        <p                                                                   
          class="my-3 font-weight-bolder"
        >
          This cannot be undone. Are you sure?
        </p>

        <div class="button-wrap d-flex">
          <el-button
            @click="onClose($event)"
          >
            Go, back
          </el-button>
          <el-button
            type="primary"
            :loading="mainLoader"
            @click.prevent="action === 'close' ? closeAccount() : suspendAccount()"
          >
            Yes, {{ action }} my account
          </el-button>
        </div>
      </div>
    </el-dialog>
  </focus-lock>
</template>

<script>
import store from '@/store'
import gsApi from '@/services/gs.api'
import svgDangerExclamation from '@/components/assets/svg-danger-exclamation'

export default {

  components: {
    svgDangerExclamation,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    newOwner : {
      type: Object,
      default: () => {}
    },
    organisationId: {
      type: Number,
      default: null,
      required: true
    },
    action: {
      type: String,
      default: null,
      required: true
    }
  },

  data() {
    return {
      mainLoader: false,
      dialogVisible: false,
    }
  },

  watch: {
    visible(value) {
      this.dialogVisible = this.visible
    }
  },

  created() {
    this.dialogVisible = this.visible
  },

  methods : {
    onClose() {
      this.dialogVisible = false
      this.$emit('closed')
    },

    closeAccount() {
      this.mainLoader = true
      gsApi.auth.markAsClosed({owner_id: this.newOwner.id, organisation_id: this.organisationId})
        .then(() => {
          store.commit('USER_LOGOUT')
          this.$router.push('/login')
        }).catch(() => {
          this.$alert(
            '',
            `Unfortunately we're having problems contacting our service. Please try again later.`,
            {
              confirmButtonText: 'Close',
              showClose: false,
              customClass: 'notification-modal'
            }
          )
        }).finally(()=>{
          this.mainLoader = false
        })
    },
    suspendAccount() {

      this.mainLoader = true;
      gsApi.auth
        .markAsSuspended({owner_id: this.newOwner.id, organisation_id: this.organisationId})
        .then(() => {
          store.commit("USER_LOGOUT");
          this.$router.push("/login");
        })
        .catch(() => {
          this.$alert(
            "",
            `Unfortunately we're having problems contacting our service. Please try again later.`,
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal"
            }
          );
        })
        .finally(() => {
          this.mainLoader = false;
        });
    }
  }
}
</script>
